import { type Variants } from "framer-motion";

export const solViewport = { once: false, amount: 0.15 } as const;

export const solFadeRight: Variants = {
    hidden: { opacity: 0, x: -32 },
    visible: (delay = 0) => ({
        opacity: 1,
        x: 0,
        transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1], delay },
    }),
};

export const solFadeLeft: Variants = {
    hidden: { opacity: 0, x: 32 },
    visible: (delay = 0) => ({
        opacity: 1,
        x: 0,
        transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1], delay },
    }),
};

export const solStagger: Variants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.1, delayChildren: 0.05 } },
};

export const solClipUp: Variants = {
    hidden: { opacity: 0, clipPath: "inset(100% 0 0 0)" },
    visible: (delay = 0) => ({
        opacity: 1,
        clipPath: "inset(0% 0 0 0)",
        transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1], delay },
    }),
};

export const solScaleIn: Variants = {
    hidden: { opacity: 0, scale: 0.88 },
    visible: (delay = 0) => ({
        opacity: 1,
        scale: 1,
        transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1], delay },
    }),
};

export const solSlideUp: Variants = {
    hidden: { opacity: 0, y: 40 },
    visible: (delay = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1], delay },
    }),
};

export const solPortfolioFadeUp: Variants = {
    hidden: { opacity: 0, y: 36 },
    visible: (delay = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1], delay },
    }),
};

export const solPortfolioStagger: Variants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.09, delayChildren: 0.05 } },
};

export const solPortfolioGridReveal: Variants = {
    hidden: {
        opacity: 0,
        clipPath: "inset(100% 6% 0 6%)",
        filter: "blur(4px)",
    },
    visible: (delay = 0) => ({
        opacity: 1,
        clipPath: "inset(0% 0% 0% 0%)",
        filter: "blur(0px)",
        transition: { duration: 0.72, ease: [0.22, 1, 0.36, 1], delay },
    }),
};
